"use client";

import { c as _c } from "react/compiler-runtime";
import UserAvatar from "@/app/(v2)/_components/UserAvatar";
import { TokenIcon } from "@/components/ui/token-icon";
import { useSimTokenInfo } from "@/hooks/useSimTokenInfo";
import { useChainInfoMap } from "@/app/(v2)/workflows/_hooks/useChainInfo";
import { formatTokenAmount } from "../../utils/formatters";
import { containsTemplateVariable, renderValueWithVariables } from "../VariablePill";
interface SendErc20TokenPayloadProps {
  tokenAddress?: string;
  chainId?: number;
  recipientAddress?: string;
  amount?: string | number;
}

/**
 * SendErc20TokenPayload - Compact display for Send ERC20 Token actions
 * Shows: Send [token icon] [amount] [symbol] on [chain icon] [chain name] to [avatar] [address]
 */
export function SendErc20TokenPayload(t0) {
  const $ = _c(36);
  const {
    tokenAddress,
    chainId,
    recipientAddress,
    amount
  } = t0;
  const shouldFetchTokenInfo = !!(tokenAddress && chainId && tokenAddress.startsWith("0x"));
  const {
    data: simTokenData
  } = useSimTokenInfo(tokenAddress, chainId, shouldFetchTokenInfo);
  let t1;
  if ($[0] !== chainId) {
    t1 = chainId ? [chainId] : [];
    $[0] = chainId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: chainInfoMap
  } = useChainInfoMap(t1);
  const token = simTokenData?.tokens?.[0];
  let t2;
  if ($[2] !== chainId || $[3] !== chainInfoMap) {
    t2 = chainId ? chainInfoMap?.get(chainId) : undefined;
    $[2] = chainId;
    $[3] = chainInfoMap;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const chain = t2;
  const logoUrl = token?.logo || token?.token_metadata?.logo;
  let t3;
  if ($[5] !== amount) {
    t3 = containsTemplateVariable(amount);
    $[5] = amount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const amountIsVariable = t3;
  let t4;
  if ($[7] !== recipientAddress) {
    t4 = containsTemplateVariable(recipientAddress);
    $[7] = recipientAddress;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const recipientIsVariable = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span>Send</span>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== chainId || $[11] !== logoUrl || $[12] !== token || $[13] !== tokenAddress) {
    t6 = token && <TokenIcon logoUrl={logoUrl} symbol={token.symbol} chainId={chainId} tokenAddress={tokenAddress} size={16} className="flex-shrink-0" />;
    $[10] = chainId;
    $[11] = logoUrl;
    $[12] = token;
    $[13] = tokenAddress;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== amount || $[16] !== amountIsVariable || $[17] !== token?.decimals) {
    t7 = amountIsVariable ? renderValueWithVariables(amount) : <span className="text-ds-text-primary font-semibold">{formatTokenAmount(amount, token?.decimals)}</span>;
    $[15] = amount;
    $[16] = amountIsVariable;
    $[17] = token?.decimals;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== token) {
    t8 = token && <span className="text-ds-text-primary font-semibold">{token.symbol}</span>;
    $[19] = token;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>on</span>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== chain) {
    t10 = chain?.iconUrl && <img src={chain.iconUrl} alt={chain.name} className="h-4 w-4 rounded-full" />;
    $[22] = chain;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = chain?.name || `Chain ${chainId}`;
  let t12;
  if ($[24] !== t11) {
    t12 = <span className="text-ds-text-primary font-medium">{t11}</span>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== recipientAddress || $[27] !== recipientIsVariable) {
    t13 = recipientAddress && <><span>to</span>{recipientIsVariable ? renderValueWithVariables(recipientAddress) : <UserAvatar address={recipientAddress} size={16} includeAvatar={true} includeUsername={true} textClassName="font-medium text-ds-text-primary text-xs" imageClassName="h-4 w-4" />}</>;
    $[26] = recipientAddress;
    $[27] = recipientIsVariable;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t12 || $[31] !== t13 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8) {
    t14 = <div className="border-ds-border-default border-t pt-3"><div className="text-ds-text-secondary flex flex-wrap items-center gap-1.5 text-xs">{t5}{t6}{t7}{t8}{t9}{t10}{t12}{t13}</div></div>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t13;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}